import { gql } from "_graphql-types-frontend/gql";

export const CHAT_SKILLS_FOR_INPUT = gql(/* GraphQL */ `
  query ChatSkillsForInput {
    myActiveChatSkills {
      id
      name
      description
    }
  }
`);

export const CHAT_AGENTS_FOR_INPUT = gql(/* GraphQL */ `
  query ChatAgentsForInput {
    mySpawnableChatAgents {
      id
      name
      description
    }
  }
`);

export const SAVE_STORED_PROMPT = gql(/* GraphQL */ `
  mutation AddStoredPrompts($input: StoredPromptsInput!) {
    addStoredPrompts(input: $input) {
      id
      prompt
    }
  }
`);

export const GET_STORED_PROMPTS_LIST = gql(/* GraphQL */ `
  query GetStoredPromptsList(
    $page: PageInput
    $sort: [StoredPromptsSort!]
    $filter: StoredPromptsFilter
  ) {
    storedPromptsList(page: $page, sort: $sort, filter: $filter) {
      items {
        id
        prompt
      }
      total
    }
  }
`);
